module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = ./node_modules/core-js/library/modules/_library.js
// module chunks = 1